import brand from '../resources/hplLogo.png';
import _ from 'lodash'
import Help from '../features/help/Help';


const mainNavConfig = {
    brand,
    header: {
        prefix: 'Authorized Installer',
        suffix: 'Portal'
    },
    defaultActiveNavID: 'home',
    links: [
        { name: 'Home', link: '/', id: 'home' }
    ],
    rightMenuLinks: [Help]
}

const addNewLink = (link)=>{
    if(!_.some(mainNavConfig.links, link))  mainNavConfig.links.push(link)
}

const defaultActiveNavID = mainNavConfig.defaultActiveNavID

export { defaultActiveNavID, addNewLink };
export default mainNavConfig;
